import { Outlet } from 'react-router';
import { UniversalPage, UniversalVerticalTabs } from '@sighthost/ui';

export default function SettingsLayoutPage() {
  return (
    <UniversalPage
      title="Settings"
      description="Manage your profile, security, and preferences."
      breadcrumbs={[
        { label: 'Home', href: '/app' },
        { label: 'Settings' },
      ]}
    >
      <div className="flex gap-8">
        <UniversalVerticalTabs
          items={[
            { label: 'Profile',       to: 'profile' },
            { label: 'Security',      to: 'security' },
            { label: 'Notifications', to: 'notifications' },
            { label: 'Billing info',  to: 'billing-info' },
            { label: 'Activity',      to: 'activity' },
            { label: 'Your data',     to: 'data' },
          ]}
          withOutlet={false}
        />
        <div className="flex-1 space-y-6">
          <Outlet />
        </div>
      </div>
    </UniversalPage>
  );
}
